import React from "react";
import { useForm, Controller } from "react-hook-form";
import SHTText from "../../components/SHTText";
import SHTInput from "../../components/SHTInput";
import "../../assets/styles/page/team_information_style.css";
import SHTRadio from "../../components/SHTRadio";
import SHTButton from "../../components/SHTButton";
import { PLAYER_NO_INPUT_VALIDATION } from "../../utils/validation";
import useFormPersistence from "../../utils/helper/useFormPersist";

interface FormInputs {
  no_of_player: any;
  player_payment_disclosure: string;
  player_payment_status: any;
}
const PlayerArrangement = ({ handleSubmitData }: any) => {
  let loginInitalValues: FormInputs = {
    no_of_player: "",
    player_payment_disclosure: "",
    player_payment_status: "",
  };

  const {
    control,
    getValues,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: loginInitalValues,
  });

  const onSubmit = (data: FormInputs) => {
    // Access the selected radio value from data.player_payment_status
    console.log("Selected Radio Value:", data.player_payment_status);

    // Call the external submit handler

    setValue("no_of_player", parseInt(data.no_of_player));
    console.log(getValues("no_of_player"));

    handleSubmitData(data);
  };

  // Use the custom hook to handle form persistence
  useFormPersistence<FormInputs>("playerArrangement", setValue, watch);

  const RadiOptions = [
    {
      label: "Yes",
      value: true,
    },
    {
      label: "No",
      value: false,
    },
  ];
  return (
    <section className="first_form_container team_management">
      <div className="pb-4">
        <SHTText size="h2" text="Player Arrangement" color="gray" />
      </div>
      <div className="form_list">
        <SHTText
          size="p"
          text=<p className="labe_text">
            Maximum number of players you expect to have on your team <br />{" "}
            <b>(Must be at least 25 players)</b>
          </p>
        />
        <Controller
          control={control}
          name="no_of_player"
          rules={PLAYER_NO_INPUT_VALIDATION}
          render={({ field: { value, onChange } }) => (
            <SHTInput
              label=""
              placeholder=""
              type="messageText"
              value={value}
              error={errors.no_of_player && errors.no_of_player.message}
              onChangeText={onChange}
            />
          )}
        />

        <div className="mt-4">
          <SHTRadio
            name="player_payment_status"
            options={RadiOptions}
            control={control}
            onRadioChange={(value) => setValue("player_payment_status", value)} // Set the selected value to the form state
            legend=<p className="radio_text">
              Do you have any player that are currently being paid in your team?{" "}
              <b>
                (Payment includes any form of compensation other than
                transportation and logistics to and fro team events)
              </b>
            </p>
          />
        </div>

        <div className="my-5">
          <Controller
            control={control}
            name="player_payment_disclosure"
            rules={{
              required: "Player disclosure is needed",
            }}
            render={({ field: { value, onChange } }) => (
              <SHTInput
                label="Player Payment Disclosure"
                placeholder=""
                type="messageText"
                value={value}
                // editable={loading}
                error={
                  errors.player_payment_disclosure &&
                  errors.player_payment_disclosure.message
                }
                onChangeText={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className="next_button player_form_button">
        <SHTButton
          type="submit"
          name="Next Page"
          handleClick={handleSubmit(onSubmit)}
        />
      </div>
    </section>
  );
};

export default PlayerArrangement;
